<template>
  <div class="events" :class="[selected.view, selected.duration, {isSearch: selected.isSearch}]">
    <template v-if="isLoading">
      <div class="loader-container">
        <span class="loader" />
      </div>
    </template>
    <template v-else-if="isEmpty(events)">
      <div class="no-event">
        {{ $filters.translate('T_NO_EVENT') }}

        <div v-if="selected.isSearch" class="button-previous" @click="onClickBackToAllEvents">
          <div class="arrow arrow-left" />
          <div class="label">
            {{ $filters.translate('T_BACK_TO_ALL_EVENTS') }}
          </div>
        </div>
      </div>
    </template>
    <template v-else>
      <div v-for="eventGroup in eventGroups" class="event-group">
        <div class="event-group-header">
          <div class="event-group-title">
            <template v-if="selected.isSearch">
              <span class="sub-text">
                <span class="search no-of-events"> {{ eventGroup.noOfEventsText }}</span>
              </span>
            </template>
            <template v-else>
              <span class="main-text">
                {{ eventGroup.dateText }}
              </span>
              <span class="sub-text">
                <template v-if="eventGroup.weekdayText">
                  ({{ eventGroup.weekdayText }})
                </template>
                <span class="no-of-events"> {{ eventGroup.noOfEventsText }}</span>
              </span>
            </template>
          </div>

          <div v-if="selected.isSearch" class="button-previous" @click="onClickBackToAllEvents">
            <div class="arrow arrow-left" />
            <div class="label">
              {{ $filters.translate('T_BACK_TO_ALL_EVENTS') }}
            </div>
          </div>
        </div>
        <div class="event-group-events-view">
          <div v-for="(event, idx2) in eventGroup.events" class="event" :class="`mod-index-${idx2%3}`" @click="onClickEvent(event)">
            <div v-if="selected.view === 'list'" class="category-bar" :style="{backgroundColor: event.category.bgColor}" />
            <div class="first-line">
              <div
                class="poster"
                :style="{backgroundImage: `url(./files/${event.photo})`}"
              />
              <h1>{{ $filters.translate(event.title) }}</h1>
            </div>
            <div class="grid-inf-wrapper" :class="{isSearch: selected.isSearch}">
              <h1>{{ $filters.translate(event.title) }}</h1>
              <div v-if="selected.view === 'grid'" class="category-bar" :style="{backgroundColor: event.category.bgColor}" />
              <h3 v-if="selected.isSearch || selected.duration==='week'">
                <span class="icon icon-calendar" />
                <span class="label">
                  {{ getEventDateText(event) }}
                </span>
              </h3>
              <h3 v-if="!isEmpty(getTimeText(event))">
                <span class="icon icon-clock" />
                <span class="label">
                  {{ getTimeText(event) }}
                </span>
              </h3>
              <h3 v-if="!isEmpty(getLocationText(event))">
                <span class="icon icon-location" />
                <span class="label">
                  {{ getLocationText(event) }}
                </span>
              </h3>
            </div>
            <!-- <div>{{ event }}</div> -->
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import _ from 'lodash'
import moment from 'moment'
import OverlayService from '@/services/OverlayService'
import Base from '@/components/Base'

export default {
  mixins: [
    Base
  ],
  props: [
    'selected',
    'events',
    'isLoading'
  ],
  data () {
    return {
      isEmpty: _.isEmpty,
      eventGroups: []
    }
  },
  mounted () {
    this.updateEventGroups()
  },
  methods: {
    updateEventGroups () {
      if (this.selected.isSearch) {
        this.eventGroups = this.getEventGroupsBySearch()
      } else {
        this.eventGroups = this.getEventGroupsByDate()
      }
    },
    getEventGroupsByDate () {
      const eventGroups = []
      const weekStart = moment(this.selected.date).startOf('week')
      if (this.selected.duration === 'week') {
        _.each(_.range(7), diff => {
          const date = moment(weekStart).add(diff, 'd').format('YYYY-MM-DD')
          const subEvents = _.filter(this.events, event => event.dateFrom <= date && event.dateTo >= date)
          if (!_.isEmpty(subEvents)) {
            const dateText = this.getDateText(date)
            const weekdayText = this.$filters.translate(`T_WEEK_DAY_${moment(date).weekday()}`)
            const noOfEventsText = `${_.size(subEvents)} ${this.$filters.translate('T_EVENTS')}`
            eventGroups.push({
              dateText,
              weekdayText,
              noOfEventsText,
              events: subEvents
            })
          }
        })
      } else {
        const date = this.selected.date
        const dateText = this.getDateText(date)
        const weekdayText = this.$filters.translate(`T_WEEK_DAY_${moment(date).weekday()}`)
        const noOfEventsText = `${_.size(this.events)} ${this.$filters.translate('T_EVENTS')}`
        eventGroups.push({
          dateText,
          weekdayText,
          noOfEventsText,
          events: this.events
        })
      }
      // do event sorting
      _.each(eventGroups, eventGroup => {
        eventGroup.events = _.sortBy(eventGroup.events, event => {
          if (event.isFull === 'F') {
            return ''
          }
          return `${event.timeFrom}:${event.timeTo}-${event.timeFrom2}:${event.timeTo2}`
        })
      })
      return eventGroups
    },
    getEventGroupsBySearch () {
      const eventGroups = []
      const startDate = _.min(_.compact(_.map(this.events, 'dateFrom')))
      const endDate = _.max(_.compact(_.map(this.events, 'dateTo')))

      const noOfEventsText = `${_.size(this.events)} ${this.$filters.translate('T_EVENTS')}`
      const dateText = this.getGroupBySearchDateText({ dateFrom: startDate, dateTo: endDate })
      eventGroups.push({
        dateText,
        weekdayText: null,
        noOfEventsText,
        events: this.events
      })

      return eventGroups
    },
    getLocationText (event) {
      return _.compact([
        this.$filters.translate(event.locationOther),
        this.$filters.translate(_.get(event, 'location.name'))
      ]).join(', ')
    },
    getTimeText (event) {
      if (event.isFull === 'F') {
        return this.$filters.translate('T_FULL_DAY')
      } else {
        return _.uniq(_.compact([
          _.compact([event.timeFrom, event.timeTo]).join(':'),
          _.compact([event.timeFrom2, event.timeTo2]).join(':')
        ])).join(' - ')
      }
    },
    onClickEvent (event) {
      OverlayService.setEvent(event)
    },
    onClickBackToAllEvents () {
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/_variables.scss';

.events {
  min-height: 210px;
  .no-event {
    width: 100%;
    font-size: 40px;
    line-height: 150px;
    margin-bottom: 50px;
    text-align: center;
    display: block;
  }

  &.grid {
    .event {
      display: block;
      .grid-inf-wrapper {
        h1 {
          display: none;
        }
      }
    }
  }

  .event {
    cursor: pointer;
    position: relative;
    // padding: 34px 27px;
    padding-right: 37px;
    margin-bottom: 10px;
    display: flex;

    .category-bar {
      // background-color: red;
      // opacity: 0.5;
      width: 16px;
      height: 100%;
      position: absolute;
      right: 0px;
      top: 0px;
    }
    .poster {
      display: block;
      width: 184px;
      height: 258px;
      background-image: url('@/assets/dummy-cover.png');
      background-size: contain;
      background-repeat: no-repeat;
      background-position: center center;
    }
    h1 {
      color: $color-hkbu-blue-background;
      font-size: 18px;
      margin-bottom: 32px;
      line-height: 27px;
    }
    h3 {
      display: block;
      display: flex;
      align-items: start;
      margin-bottom: 15px;
      color: #333333;

      &:last-child {
        margin-bottom: 0px;
      }

      .icon {
        display: inline-block;
        min-width: 22px;
        width: 22px;
        height: 22px;
        background-repeat: no-repeat;
        background-position: center center;
        background-size: contain;
        &.icon-clock {
          background-image: url('@/assets/icon-clock.png');
        }
        &.icon-location {
          background-image: url('@/assets/icon-location.png');
        }
        &.icon-calendar {
          background-image: url('@/assets/icon-calendar.svg');
        }
      }

      >.label {
        font-size: 16px;
        margin-top: 2px;
        margin-left: 8px;
        display: inline-block;
        font-size: 16px;
        line-height: 20px;
      }
    }

    .first-line {
      h1 {
        display: none;
      }
    }

    .grid-inf-wrapper {
      padding: 34px 27px;
    }

    &:nth-child(odd) {
      background-color: #F5F8FA;
    }

    &:hover {
      h1 {
        color: $color-light-blue
      }
      h3 {
        color: #888888;
      }
    }
  }

  .event-group {
    margin-bottom: 50px;
  }
  .event-group-title {
    display: none;
    color: white;
    padding: 14px 30px;
    background-color: $color-hkbu-blue;
    .main-text {
      font-size: 20px;
      font-family: Poppins-Medium;
    }
    .sub-text {
      font-size: 16px;
    }
    .no-of-events {
      margin-left: 15px;
    }
    .no-of-events.search {
      margin-left: 0px;
    }
  }
  .event-group-header {
    display: flex;

    .button-previous {
      margin-left: 40px;
    }
  }

  .button-previous {
    margin-left: 20px;
    // position: absolute;
    cursor: pointer;
    display: flex;
    align-items: center;
    // border: 1px green solid;
    &.button-previous {
      left: 0px;
    }
    &.button-next {
      right: 0px;
    }

    .label {
      display: inline-block;
      margin: 0px 8px;
      color: #333333;
      font-size: 16px;
    }

    &:hover {
      .arrow {
        border-color: $color-light-blue;
      }
      .label {
        color: #888888;
      }
    }
  }

  .arrow {
    border: solid $color-hkbu-blue-background;
    border-width: 0 5px 5px 0;
    display: inline-block;
    padding: 8px;
  }
  .arrow-left {
    margin-left: 5px;
    transform: rotate(135deg);
    -webkit-transform: rotate(135deg);
  }
  .arrow-right {
    margin-right: 5px;
    transform: rotate(-45deg);
    -webkit-transform: rotate(-45deg);
  }

  @media screen and (min-width: 769px)
  {
    &.grid {

      .event-group {
        margin-bottom: 20px;
      }

      .event-group-events-view {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
      }

      .event-group-events-view {
        &::after {
          content: "";
          flex: auto;
        }
      }
      .event {
        margin-bottom: 40px;
        background-color: white;
        width: calc((100% - 50px) /3);
        padding: 0px;

        &.mod-index-1, &.mod-index-2 {
          margin-left: 25px;
        }
        .first-line {
          background-color: #F5F8FA;
          display: flex;
          align-items: center;
          overflow: hidden;
          h1 {
            width: calc(100% - 184px);
            display: inline-block;
            // border: 1px red solid;
            margin: 0px;
            padding: 0px 10px;
            max-height: 258px;
            display: -webkit-box;
            -webkit-line-clamp: 8;
            -webkit-box-orient: vertical;
            overflow: hidden;
          }
          .poster {
            display: inline-block;
          }
        }
        .grid-inf-wrapper {
          position: relative;
          background-color: #EDEDED;
          padding: 30px 30px 30px 20px;
          min-height: 210px;
          height: auto;
          // &.isSearch {
          //   height: 210px;

          // }
        }
      }

    }
  }

  &.week {
    .event-group-title {
      display: inline-block;
    }
  }

}

.loader-container {
  display: flex;
  justify-content: center;

  .loader {
    width: 100px;
    height: 100px;
    border: 5px solid $color-hkbu-blue-background;
    border-bottom-color: transparent;
    border-radius: 50%;
    display: inline-block;
    box-sizing: border-box;
    animation: rotation 1s linear infinite;
    }

    @keyframes rotation {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
  }
}

@media screen and (max-width: 1280px)
{
  .events {
    .event-group-title {
      .main-text {
        font-size: 20px;
      }
      .sub-text {
        font-size: 14px;
      }
    }
    .event {
      h1 {
        font-size: 16px;
        max-height: 225px;
      }
      h3 {
        .label {
          font-size: 14px;
        }
      }
      .category-bar {
        width: 14px;
      }
      .first-line {
        .poster {
          width: 160px;
          height: 228px;
        }
      }
    }

    @media screen and (min-width: 769px) {
      &.grid {
        .event {
          width: calc((100% - 25px) / 2);
          &:nth-child(odd) {
            margin-left: 0px;
          }
          &:nth-child(even) {
            margin-left: 25px;
          }
          h1 {
            max-height: 225px;

            -webkit-box-orient: vertical;
            display: -webkit-box;
            -webkit-line-clamp: 5;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: normal;

          }
        }
      }
    }
  }
}

@media screen and (max-width: 768px)
{

  .events {
    .event-group {
      margin-bottom: 38px;
      margin-left: 25px;
    }
    .event-group-title {
      padding: 14px 25px;
      .main-text {
        font-size: 18px;
      }
      .sub-text {
        font-size: 14px;
      }
    }
    .event {
      display: flex !important;
      margin-right: 25px;
      padding-right: 14px;
      h1 {
        font-size: 15px;
        margin-bottom: 20px;
        max-height: none;
      }
      h3 {
        .label {
          font-size: 13px;
        }
      }
      .category-bar {
        width: 14px;
      }
      .first-line {
        .poster {
          width: 100px;
          height: 140px;
        }
      }
      .grid-inf-wrapper {
        padding: 16px;
        h1 {
          display: block !important;
        }
      }
    }
  }
}
</style>
